// extracted by mini-css-extract-plugin
var _1 = "RestrictedViewStyles-module__message____AAIm";
export { _1 as "message" }
